module.exports = __webpack_public_path__ + "img/thermometer.eb00edd3.png";